import React from "react";
import { Box } from "@mui/system";
import { Typography, Grid } from "@mui/material";

export default function AttachmentFile(props) {
  return (
    <Box
      sx={{
        display: "flex",
        borderBottom: 1,
        borderColor: "#eee",
        p: "20px",
      }}
    >
      <Grid container>
        <Grid item xs={4} sm={3}>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
              width: { xs: "120px", sm: "180px" },
            }}
          >
            添付ファイル
          </Typography>
        </Grid>
        <Grid item xs={8} sm={9}>
          <Typography sx={{ fontSize: "14px" }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  process.env.REACT_APP_URL +
                    "api/personnel_download?personnel_id=" +
                    props.id,
                  "_blank"
                );
              }}
            >
              {props.filename}
            </a>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
